import { RemoteSearchDoctors } from '../../../data/usecases/search-doctors/remote-search-doctors'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeSearchDoctors = (companyId: number) => new RemoteSearchDoctors(
  `/rankings/contractor/search/${companyId}`,
  makeAxiosHttpClient(),
)
